
import { LinksDropdown } from "/react4xp/parts/links-dropdown/links-dropdown";

export default (props) => <LinksDropdown {...props} />
